import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { respuestaWebpay } from "../interfaces/respuestaWebpay";

@Injectable()
export class SharingService {
    private dataSharing: BehaviorSubject<any> = new BehaviorSubject<respuestaWebpay>({ dato: '' });

    get sharingObservable() {
        return this.dataSharing.asObservable();
    }

    set sharingObservableData(data: string) {
        this.dataSharing.next(data);

    }

}